<template>
  <div>
    <el-row>
      <el-col>
        <el-button type="primary" size="medium" style="margin-top:20px" @click="addNature">新增企业性质</el-button>
        <el-button type="primary" size="medium" style="margin-top:20px" @click="openCheckout">校验项管理</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table stripe border :data="newTableData" style="margin-top:20px">
          <el-table-column label="序号" type="index" width="400" min-width="100"></el-table-column>
          <el-table-column label="企业性质" prop="NATURE_NAME"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="mateCheckout(scope.row)">匹配校验项</el-button>
              <el-button type="text" size="small" @click="del(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: right">
        <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
          layout="total,prev, pager, next, jumper" :total="totalCount"></el-pagination>
      </el-col>
    </el-row>
    <!-- 新增企业性质 -->
    <el-dialog :visible.sync="addCompanyNatureDialog" @close="addCompanyNatureDialog = false" title="新增企业性质" width="400px" center>
      <el-form ref="addNatureForm" :model="addNatureForm" size="small" :label-width="'100px'" :inline="true">
        <el-form-item label="一级企业性质:">
          <el-select filterable v-model="addNatureForm.firstNatureList" @change="firstNature" placeholder="请选择" clearable>
            <el-option v-for="item in fNatureList" :key="item.FIRST_NATURE_CODE" :label="item.FIRST_SUPPLIER_NATURE"
              :value="item.FIRST_NATURE_CODE"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二级企业性质:">
          <el-select filterable v-model="addNatureForm.secondNatureList" placeholder="请选择" clearable>
            <el-option v-for="item in sNatureList" :key="item.SECOND_NATURE_CODE" :label="item.SECOND_SUPPLIER_NATURE"
              :value="item.SECOND_NATURE_CODE"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center;">
        <el-button class="operate-btn" @click="addCompanyNatureDialog = false">取消</el-button>
        <el-button class="operate-btn" @click="handleAddCompanyNature">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import http from '@/assets/common/http';

export default {
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      tableData: [],
      newTableData: [],
      addNatureForm: {
        firstNatureList: '',
        secondNatureList: '',
      },
      fNatureList: [],
      sNatureList: [],
      addCompanyNatureDialog: false,
      editCompanyNatureDialog: false,
    };
  },
  created() {
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.SAVE_DSORDER_LIST) {
      this.currentPage = this.SAVE_DSORDER_LIST.CURRENT_PAGE;
    } else {
      this.currentPage = 1;
    }
    this.queryTable();
    this.getFirstNature();
    this.getSecondNature();
  },
  methods: {
    // 页码
    handleCurrentChange(val) {
      this.currentPage = val;
      this.queryTable();
    },
    sizeChange(val) {
      this.currentPage = 1;
      this.pageSize = val;
      this.queryTable();
    },
    // 进入页面拉取数据
    queryTable() {
      const params = {
        SERVICE_ID: '10002',
        OTYPE: 10,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        PAGEINDEX: this.currentPage - 1,
        PAGESIZE: this.pageSize,
      };
      http.post(params).then((result) => {
        if (result.length !== 0) {
          this.tableData = result[0].LIST;
          // this.newTableData = this.tableData.slice((this.currentPage - 1) * this.pageSize, this.currentPage * this.pageSize);
          this.newTableData = this.tableData;
          this.totalCount = result[0].TOTAL_COUNT;
        } else {
          this.$message.show({ text: '暂无数据', type: 'warning' });
          this.newTableData = [];
        }
      });
    },
    // 获取一级企业性质
    getFirstNature() {
      const params = {
        SERVICE_ID: '10002',
        OTYPE: 11,
      };
      http.post(params).then((res) => {
        this.fNatureList = res;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 一级企业性质改变
    firstNature() {
      this.addNatureForm.secondNatureList = '';
      this.getSecondNature();
    },
    // 获取二级企业性质
    getSecondNature() {
      const params = {
        SERVICE_ID: '10002',
        OTYPE: 12,
      };
      if (this.addNatureForm.firstNatureList) {
        params.FIRST_NATURE_CODE = this.addNatureForm.firstNatureList;
      }
      http.post(params).then((res) => {
        this.sNatureList = res;
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 新增企业性质按钮
    addNature() {
      this.addCompanyNatureDialog = true;
    },
    // 提交新增企业性质
    handleAddCompanyNature() {
      const params = {
        SERVICE_ID: '10002',
        OTYPE: 13,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
      };
      if (this.addNatureForm.secondNatureList) {
        params.SECOND_NATURE_CODE = this.addNatureForm.secondNatureList;
      } else {
        this.$message.show({ text: '请选择二级企业性质', type: 'warning' });
        return false;
      }
      http.post(params).then((result) => {
        this.$message.show({ text: '新增成功', type: 'success' });
        this.addCompanyNatureDialog = false;
        this.queryTable();
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    // 删除企业性质
    del(row) {
      const params = {
        SERVICE_ID: '10002',
        OTYPE: 14,
        NATURE_RECORD_ID: row.NATURE_RECORD_ID,
      };
      http.post(params).then((result) => {
        this.$message.show({ text: '删除成功', type: 'success' });
        this.queryTable();
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    // 校验项管理
    openCheckout() {
      this.$router.push({ name: 'qualificationItemManagement' });
    },
    // 匹配校验项
    mateCheckout(row) {
      this.$router.push({ path: `/matchQualifications/${row.NATURE_RECORD_ID}/${Number(sessionStorage.getItem('tcId'))}`, params: { id: row.NATURE_RECORD_ID, gysId: Number(sessionStorage.getItem('tcId')) } });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/supplierManage/settledDisposition.vue